import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/small.png'
import _imports_1 from '@/assets/big.png'


const _withScopeId = n => (_pushScopeId("data-v-153b1e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "partner",
  id: "partner"
}
const _hoisted_2 = { class: "partner-top" }
const _hoisted_3 = { class: "partner-top-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "partner-top-name-left-img",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "partner-top-name-right-img",
  src: _imports_1
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_7 = { class: "partner-top-desc" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.partnerModule.alias) + " ", 1),
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.partnerModule.description), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_swiper, {
        class: "swiper",
        modules: _ctx.modules,
        "slides-per-view": 4,
        speed: 3000,
        observer: true,
        "space-between": 20,
        loop: "",
        observeParents: false,
        autoplay: { disableOnInteraction: false, delay: 0 },
        grabCursor: true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerModule.articles, (banner, index) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              class: "swiper-slide",
              key: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: banner.img
                }, null, 8, _hoisted_8)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}